<form
  class="profileSettings"
  (ngSubmit)="updateProfileSettings()"
  [formGroup]="userSettings"
>
  @if (user.id() && user.avatar_url()) {
    <img
      [src]="user.avatar_url()"
      alt=""
      class="profileSettings-avatar"
      (click)="avatarInput.click()"
    />
    <input
      type="file"
      accept="image/*"
      (input)="uploadAvatar(avatarInput.files)"
      style="display: none"
      #avatarInput
    />
  } @else {
    <img
      src="/assets/images/placeholders/user_placeholder.png"
      alt=""
      class="profileSettings-avatar"
      (click)="avatarInput.click()"
    />
    <input
      type="file"
      accept="image/*"
      (input)="uploadAvatar(avatarInput.files)"
      style="display: none"
      #avatarInput
    />
  }
  <mat-form-field>
    <mat-label>{{ "profilePage.name" | translate }}</mat-label>
    <input matInput formControlName="name" name="name"/>
  </mat-form-field>
  <mat-form-field>
    <mat-label>{{ "profilePage.surname" | translate }}</mat-label>
    <input matInput formControlName="last_name" name="last_name"/>
  </mat-form-field>
  <mat-form-field class="formInput">
    <mat-label>{{ "profilePage.country" | translate }}</mat-label>
    <mat-select
      [formControl]="userSettings.controls.country_id"
      [placeholder]="'profilePage.country' | translate"
    >
      <mat-option>
        <ngx-mat-select-search
          [placeholderLabel]="'profilePage.country' | translate"
          [formControl]="countryListFilter"
          [noEntriesFoundLabel]="'global.nothingFound' | translate"
        ></ngx-mat-select-search>
      </mat-option>
      @for (country of countryListFiltered(); track country.country_id) {
        <mat-option [value]="country.country_id">
          {{ country.name }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
  <mat-form-field>
    <mat-label>{{ "profilePage.language" | translate }}</mat-label>
    <mat-select formControlName="language_id">
      @for (lang of languageList(); track lang.id) {
        <mat-option [value]="lang.id">{{ lang.name }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
  <mat-form-field class="formInput">
    <mat-label>{{ "profilePage.timeZone" | translate }}</mat-label>
    <mat-select
      [formControl]="userSettings.controls.timezone_id"
      [placeholder]="'profilePage.timeZone' | translate"
    >
      <mat-option>
        <ngx-mat-select-search
          [placeholderLabel]="'profilePage.timeZone' | translate"
          [formControl]="timezoneListFilter"
          [noEntriesFoundLabel]="'global.nothingFound' | translate"
        ></ngx-mat-select-search>
      </mat-option>
      @for (time of timezoneListFiltered(); track time.id) {
        <mat-option [value]="time.id">
          {{ $t.defaultLang === "ru" ? time.value : time.value_en }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
  <button
    type="submit"
    class="btn btn-primary"
    [disabled]="userSettings.invalid"
  >
    {{ "global.update" | translate }}
  </button>
</form>
